define('views/modules/questionnaire/edit/questionnaire-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/questionnaire/questionnaire',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/edit/questionnaire-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MQuestionnaire,
    // views
    VBasePanel,
    VQuestionnaireEditContent
) {

    var VQuestionnaireEditPanel = VBasePanel.extend({
        header: {
            title: "questionnaire:Questionnaire",
            subtitle: "questionnaire:Adding/Modify a questionnaire",
        },
        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        content: { edit: VQuestionnaireEditContent, },

        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};
            this.model = new MQuestionnaire();
            var edit = this.getView('edit', {
                model: this.model,
                group: opt.group,
            });
            this.listenTo(edit, {
                'form:success': this.onSuccess,
                'questionnaire:show-questions': this.onShowQuestions
            });
        },

        setModel: function(model) {
            if (model) {
                var attrs = model.attributes || model;
                this.model.reset(attrs);
                this.model.fetch();
            }
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        onShowQuestions: function(model) {
            this.trigger('questionnaire:show-questions', model);
        },

        onSuccess: function() {
            this.close();
            this.trigger('form:success', this.model);
        },

    });

    return VQuestionnaireEditPanel;

});

